var __asyncValues = this && this.__asyncValues || function (o) {
    if (!Symbol.asyncIterator)
        throw new TypeError('Symbol.asyncIterator is not defined.');
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === 'function' ? __values(o) : o[Symbol.iterator](), i = {}, verb('next'), verb('throw'), verb('return'), i[Symbol.asyncIterator] = function () {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function (v) {
            return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import { classifyConvert } from '@ef-carbon/classification';
import set from './classify/set';
export async function classify(input, targets, classifier) {
    var e_1, _a;
    const context = {};
    const klass = classifyConvert(classifier);
    try {
        for (var _b = __asyncValues(klass.classify(input, targets)), _c; _c = await _b.next(), !_c.done;) {
            let _d = _c.value;
            const {target} = _d, rest = __rest(_d, ['target']);
            set(context, target, Object.assign({}, rest));
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (_c && !_c.done && (_a = _b.return))
                await _a.call(_b);
        } finally {
            if (e_1)
                throw e_1.error;
        }
    }
    return context;
}
export default classify;    //# sourceMappingURL=classify.js.map
